import React, { useState } from 'react';

import {
  ActivityHeaderSectionWithSearchLayout,
  CustomIcon,
  SaveStandardAreaInstallationModal
} from 'modules';
import {
  Button,
  useTheme
} from '@mui/material';

export type StandardAreaInstallationsHeaderSectionProps = {};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const FC = (props: StandardAreaInstallationsHeaderSectionProps) => {

  return (
    <ActivityHeaderSectionWithSearchLayout.FC
      title='Standard Area Selections'
      backButton={(<Button variant='contained'>Back</Button>)}
      overideReturnPath='/organization/projects'
      subtitle='Selections that are automatically generated'
      searchBar={<></>}
      actionButtons={(
        <ActionButtonsGroup />
      )}
    />

  );
};

export type ActionButtonsGroupProps = {};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const ActionButtonsGroup = (props: ActionButtonsGroupProps) => {
  const [
    isVisible,
    setIsVisible
  ] = useState<boolean>(false);
  const theme = useTheme();

  return (
    <>
      {
        isVisible && (
          <SaveStandardAreaInstallationModal.FC
            id=''
            isVisible={isVisible}
            handleClose={() => setIsVisible(() => false)}
          />
        )
      }
      <Button
        variant='contained'
        startIcon={(
          <CustomIcon.large.FC
            icon='PLUS'
            stroke={theme.palette.primary.contrastText}
          />
        )}
        onClick={() => {
          setIsVisible(() => true);
        }}
      >
        Create Selection
      </Button>
    </>

  );
};
